import React, {
  useCallback,
  useEffect,
  useState,
} from 'react'
import { useResponsiveWrapperContext } from '@usap/uicomponents'
import {
  AnswerText,
  BestAnswer,
  QuestionText,
  SeeMore,
} from './style/QuestionAnswerText.css'

export default function QuestionAnswerText({ text, type = 'question' }) {
  const { isDesktop } = useResponsiveWrapperContext()
  const [maxLength, setMaxLength] = useState(58)
  const [isExpand, setIsExpand] = useState(true)
  const countString = text ? text.length : 0
  const differenceLen = countString - maxLength
  const isOverflowText = countString > maxLength && differenceLen > 10

  useEffect(() => {
    setIsExpand(false)
    setMaxLength(isDesktop ? 58 : 50)
  }, [isDesktop])

  const handleExpand = useCallback(() => {
    if (isExpand) {
      setIsExpand(false)
    } else {
      setIsExpand(true)
    }
  }, [isExpand])

  const textDisplay = useCallback(() => {
    let newText = text
    if (isOverflowText && !isExpand) {
      newText = text.substr(0, maxLength)
      return `${newText}...`
    }
    return text
  }, [isExpand, isOverflowText, maxLength, text])

  if (type === 'question') {
    return (
      <QuestionText>
        { textDisplay() }
        {
          isOverflowText && !isExpand && (
            <SeeMore onClick={handleExpand}>
              Show More
            </SeeMore>
          )
        }
        {
          isOverflowText && isExpand && (
            <SeeMore onClick={handleExpand}>
              &nbsp;Show Less
            </SeeMore>
          )
        }
      </QuestionText>
    )
  }

  return (
    <AnswerText>
      <BestAnswer>
        BEST ANSWER
      </BestAnswer>
      <AnswerText dangerouslySetInnerHTML={{ __html: textDisplay() }} />
      {
        isOverflowText && !isExpand && (
          <SeeMore onClick={handleExpand}>
            Show more
          </SeeMore>
        )
      }
      {
        isOverflowText && isExpand && (
          <SeeMore onClick={handleExpand}>
            &nbsp;Show less
          </SeeMore>
        )
      }
    </AnswerText>
  )
}
